import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { useNavigate } from "react-router-dom";

const useBackLock = () => {
  const [isLocked, setIsLocked] = useState(true);
  const handlingRef = useRef(false);
  const modalOpenRef = useRef(false);
  const isMountedRef = useRef(true);
  const navigate = useNavigate();

  const showLeaveWarning = async () => {
    if (modalOpenRef.current || Swal.isVisible()) return false;

    modalOpenRef.current = true;

    const result = await Swal.fire({
      icon: "warning",
      title: "Leave this page?",
      text: "Your progress will be lost.",
      showCancelButton: true,
      confirmButtonText: "Yes, leave",
      cancelButtonText: "Stay",
      allowOutsideClick: false,
      allowEscapeKey: false,
      reverseButtons: true,
    });

    modalOpenRef.current = false;
    return result.isConfirmed === true;
  };

  useEffect(() => {
    isMountedRef.current = true;

    // Push a dummy state to intercept back button
    window.history.pushState({ locked: true }, "");

    const handlePopState = async (e) => {
      // Prevent concurrent handling
      if (handlingRef.current) return;
      handlingRef.current = true;

      // Immediately push state forward to counter the back navigation
      window.history.pushState({ locked: true }, "");

      try {
        const shouldLeave = await showLeaveWarning();

        if (!isMountedRef.current) return;

        if (shouldLeave) {
          setIsLocked(false);
          
          // Clean up listener
          window.removeEventListener("popstate", handlePopState);
          
          // Navigate back to actual previous page
          navigate('/context-not-found', { state: { openedViaButton: true } });
          
        }
      } finally {
        handlingRef.current = false;
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      isMountedRef.current = false;
      window.removeEventListener("popstate", handlePopState);
      
      if (Swal.isVisible()) {
        Swal.close();
      }
    };
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isLocked) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isLocked]);

  return { isLocked };
};

export default useBackLock;